export const styles = {
    pageBackground: { backgroundColor: '#606c76', minHeight: '100vh', padding: '10px 0' },
    container: { width: '95%', maxWidth: '1400px', margin: '0 auto', backgroundColor: '#fff', boxShadow: '0 4px 15px rgba(0,0,0,0.3)', borderRadius: '4px', height: '85vh', display: 'flex', flexDirection: 'column', position: 'relative' },
    headerBar: { backgroundColor: '#f1f1f1', borderBottom: '1px solid #ccc', padding: '5px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
    mainTitle: { color: '#333', margin: 0, fontSize: '16px', fontWeight: 'bold', textAlign: 'center' },
    createBtn: { background: 'none', border: 'none', color: '#28a745', cursor: 'pointer', padding: '5px' },
    controls: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 15px', backgroundColor: '#e9e9e9', borderBottom: '1px solid #ccc' },
    leftControls: { display: 'flex', gap: '10px', alignItems: 'center' },
    searchBox: { display: 'flex', alignItems: 'center', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '4px 8px' },
    searchInput: { border: 'none', outline: 'none', fontSize: '14px', width: '200px' }, // Aumentado para 14px e ligeiramente mais largo
    paginationGroup: { display: 'flex', alignItems: 'center', fontSize: '14px' }, // Aumentado
    navBtn: { padding: '2px 8px', cursor: 'pointer', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '3px', margin: '0 2px' },
    pageIndicator: { margin: '0 10px', color: '#333' },
    pageInput: { width: '30px', textAlign: 'center', border: '1px solid #ccc', borderRadius: '2px' },
    countDisplay: { marginRight: '10px', color: '#666' },
    select: { padding: '2px', fontSize: '14px' }, // Aumentado
    tableContainer: { flex: 1, overflowY: 'auto' },
    table: { width: '100%', borderCollapse: 'separate', borderSpacing: 0, tableLayout: 'fixed' },
    theadSticky: { position: 'sticky', top: 0, zIndex: 10, backgroundColor: '#cce5ff' },
    theadRow: { backgroundColor: '#d9edf7' },
    th: { padding: '8px 6px', fontSize: '14px', color: '#31708f', fontWeight: 'bold', textAlign: 'center', borderRight: '1px solid #bce8f1', borderBottom: '1px solid #bce8f1' }, // Aumentado padding e font
    groupHeaderRow: { backgroundColor: '#212529' },
    groupTd: {
        padding: '8px 10px', color: '#fff', fontWeight: 'bold', fontSize: '14px', // Aumentado padding e font
        borderRight: '1px solid #444'
    },
    // ---- ZEBRA STRIPING ----
    dataRow: { borderBottom: '1px solid #dee2e6', backgroundColor: '#fff' },
    dataRowAlt: { borderBottom: '1px solid #dee2e6', backgroundColor: '#f2f2f2' }, // NOVA: Cinzento claro para alternar

    td: {
        padding: '6px 10px', fontSize: '14px', color: '#333', // Aumentado font
        borderRight: '1px solid #eee', textAlign: 'center',
        overflow: 'hidden', textOverflow: 'ellipsis'
    },
    tdActions: { padding: '4px 2px', textAlign: 'center' },
    iconBtn: { border: '1px solid #ccc', background: '#fff', fontSize: '16px', cursor: 'pointer', padding: '2px 6px', margin: '0 2px', borderRadius: '3px' }, // Aumentado icon

    // Modais
    modalOverlay: { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000 },
    modalContent: { backgroundColor: '#fff', color: '#333', width: '90%', maxWidth: '600px', borderRadius: '5px', padding: '15px', boxShadow: '0 0 20px rgba(0,0,0,0.5)', display: 'flex', flexDirection: 'column', maxHeight: '90vh' },
    modalContentLarge: { backgroundColor: '#fff', width: '95%', maxWidth: '1200px', borderRadius: '5px', padding: '15px', boxShadow: '0 0 20px rgba(0,0,0,0.5)', display: 'flex', flexDirection: 'column', height: '90vh' },
    modalScroll: { overflowY: 'auto', marginBottom: '15px' },
    modalTitle: { margin: '0 0 15px 0', fontSize: '18px', color: '#333', borderBottom: '2px solid #005c75', paddingBottom: '5px' },
    infoTable: { width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc' },
    infoSectionHeader: { backgroundColor: '#005c75', color: '#fff', fontSize: '14px', textAlign: 'center' }, // Aumentado
    infoLabel: { width: '30%', backgroundColor: '#f2f2f2', color: '#333', fontWeight: 'bold', textAlign: 'right', padding: '6px', fontSize: '14px', border: '1px solid #ccc' }, // Aumentado
    infoVal: { padding: '6px', fontSize: '14px', color: '#333', border: '1px solid #ccc' }, // Aumentado
    modalInput: { width: '100%', padding: '6px 4px', border: '1px solid #ccc', fontSize: '14px', boxSizing: 'border-box' }, // Aumentado
    modalFooter: { display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: 'auto' },
    modalFooterCenter: { display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' },
    footerBtn: { padding: '6px 20px', cursor: 'pointer', borderRadius: '3px', border: '1px solid #999', background: '#e1e1e1', fontSize: '14px', color: '#333' }, // Aumentado
    dropZone: { border: '2px dashed #1D6F42', borderRadius: '4px', padding: '20px', textAlign: 'center', backgroundColor: '#f9fffb', cursor: 'pointer', margin: '10px 0' },

    // Tabs & Upload
    tab: { padding: '10px 20px', cursor: 'pointer', borderBottom: '2px solid transparent', fontWeight: 'bold', color: '#666' },
    tabActive: { padding: '10px 20px', cursor: 'pointer', borderBottom: '2px solid #005c75', fontWeight: 'bold', color: '#005c75' },
    uploadBtn: { display: 'inline-flex', alignItems: 'center', padding: '4px 10px', backgroundColor: '#e9ecef', border: '1px solid #ced4da', borderRadius: '3px', cursor: 'pointer', fontSize: '14px' }, // Aumentado

    importErrorsList: {
        marginTop: '8px',
        paddingLeft: 0,
        listStyleType: 'none'
    },

    importErrorSheet: {
        marginBottom: '12px'
    },

    importErrorSheetTitle: {
        fontWeight: 500,
        marginBottom: '6px'
    },

    importErrorSublist: {
        margin: 0,
        paddingLeft: '22px',
        listStyleType: 'disc'
    },

    importErrorSublistItem: {
        marginBottom: '4px'
    }
};